"use strict";
/*
  PNG parsing library with metadata reading/writing functionality. Copyright (C) 2020-2021 Vereign AG

  This program is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General
  Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option)
  any later version.

  This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied
  warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
  details.

  You should have received a copy of the GNU Affero General Public License along with this program. If not, see
  https://www.gnu.org/licenses/.

  In case of queries or questions, please contact us under by email under contact@vereign.com or by letter post to
  Vereign AG, Kolinplatz 10, 6300 Zug, Switzerland
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeTextField = exports.parseTextField = exports.crc = exports.crcUpdate = exports.readUTF8 = exports.pad = exports.readBytes = exports.writeASCII = exports.readASCII = exports.writeUint = exports.readUint = exports.writeUshort = exports.readUshort = exports.nextZero = void 0;
function nextZero(data, p) {
    while (data[p] != 0) {
        p++;
    }
    return p;
}
exports.nextZero = nextZero;
function readUshort(buff, p) {
    return (buff[p] << 8) | buff[p + 1];
}
exports.readUshort = readUshort;
function writeUshort(buff, p, n) {
    buff[p] = (n >> 8) & 255;
    buff[p + 1] = n & 255;
}
exports.writeUshort = writeUshort;
function readUint(buff, p) {
    return (buff[p] * (256 * 256 * 256) +
        ((buff[p + 1] << 16) | (buff[p + 2] << 8) | buff[p + 3]));
}
exports.readUint = readUint;
function writeUint(buff, p, n) {
    buff[p] = (n >> 24) & 255;
    buff[p + 1] = (n >> 16) & 255;
    buff[p + 2] = (n >> 8) & 255;
    buff[p + 3] = n & 255;
}
exports.writeUint = writeUint;
function readASCII(buff, p, l) {
    let s = "";
    for (let i = 0; i < l; i++) {
        s += String.fromCharCode(buff[p + i]);
    }
    return s;
}
exports.readASCII = readASCII;
function writeASCII(data, p, s) {
    for (let i = 0; i < s.length; i++) {
        data[p + i] = s.charCodeAt(i);
    }
}
exports.writeASCII = writeASCII;
function readBytes(buff, p, l) {
    const arr = [];
    for (let i = 0; i < l; i++) {
        arr.push(buff[p + i]);
    }
    return arr;
}
exports.readBytes = readBytes;
function pad(n) {
    return n.length < 2 ? "0" + n : n;
}
exports.pad = pad;
function readUTF8(buff, p, l) {
    let s = "", ns;
    for (let i = 0; i < l; i++) {
        s += "%" + pad(buff[p + i].toString(16));
    }
    try {
        ns = decodeURIComponent(s);
    }
    catch (e) {
        return readASCII(buff, p, l);
    }
    return ns;
}
exports.readUTF8 = readUTF8;
function crcUpdate(c, buf, off, len) {
    const tab = new Uint32Array(256);
    for (let n = 0; n < 256; n++) {
        let c1 = n;
        for (let k = 0; k < 8; k++) {
            if (c1 & 1) {
                c1 = 0xedb88320 ^ (c1 >>> 1);
            }
            else {
                c1 = c1 >>> 1;
            }
        }
        tab[n] = c1;
    }
    for (let i = 0; i < len; i++) {
        c = tab[(c ^ buf[off + i]) & 0xff] ^ (c >>> 8);
    }
    return c;
}
exports.crcUpdate = crcUpdate;
function crc(b, o, l) {
    return crcUpdate(0xffffffff, b, o, l) ^ 0xffffffff;
}
exports.crc = crc;
function parseTextField(data) {
    let key = "";
    let value = "";
    let addToValue = false;
    for (let i = 0; i < data.length; i++) {
        const character = data[i];
        if (character == 0) {
            addToValue = true;
            continue;
        }
        if (addToValue == false) {
            key += String.fromCharCode(character);
        }
        else {
            value += String.fromCharCode(character);
        }
    }
    return { key, value };
}
exports.parseTextField = parseTextField;
function encodeTextField(keyword, data) {
    const res = new Uint8Array(keyword.length + data.length + 1);
    let offset = 0;
    for (let i = 0; i < keyword.length; i++) {
        res[offset] = keyword.charCodeAt(i);
        offset++;
    }
    res[offset] = 0;
    offset++;
    for (let i = 0; i < data.length; i++) {
        res[offset] = data.charCodeAt(i);
        offset++;
    }
    return res;
}
exports.encodeTextField = encodeTextField;
